import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import {
  deleteTenantCasinoGameStart,
  getAllGamesStart,
  getAllSubCategoriesStart,
  updateTenantCasinoGameStatusStart
} from '../../../../store/redux-slices/tenantCasino'
import useDidMountEffect from '../../../../utils/useDidMountEffect'
import { getCasinoThemesStart } from '../../../../store/redux-slices/superAdminCasinoManagement'
import { getTenantCountriesStart } from '../../../../store/redux-slices/fetchData'
import { getTenantId } from '../../../../utils/constants'
import useAggregatorList from '../../../../shared/hooks/useAggregatorList'
import useAggregatorCategories from '../../../../shared/hooks/useAggregatorCategories'

const useCasinoGamesListing = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [limit, setLimit] = useState(15)
  const [page, setPage] = useState(1)
  const [casinoCategoryId, setCasinoCategoryId] = useState('')
  const [categoryId, setCategoryId] = useState(null)
  const [statusFilter, setStatusFilter] = useState('')
  const [subCategoryId, setSubCategoryId] = useState()
  const [categoryGameId, setCategoryGameId] = useState()
  const [active, setActive] = useState()
  const [show, setShow] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [type, setType] = useState('')
  const [deleteModalShow, setDeleteModalShow] = useState(false)
  const [showGameIds, setShowGameIds] = useState(false)
  const [gameData, setGameData] = useState()
  const [orderBy, setOrderBy] = useState('categoryGameId')
  const [sort, setSort] = useState('desc')
  const [over, setOver] = useState(false)
  const [selectedProvider, setSelectedProvider] = useState('')
  const [name, setName] = useState()
  const [search, setSearch] = useState('')
  const {
    aggregatorsOptions,
    selectedAggregatorId,
    setSelectedAggregatorId
  } = useAggregatorList({
    tenantId: getTenantId()
  })

  const {
    aggregatorsCategoryOptions,
    selectedAggregatorCategoryId,
    setSelectedAggregatorCategoryId
  } = useAggregatorCategories({
    gameAggregatorId: selectedAggregatorId,
    search,
    setSelectedProvider
  })

  const [selectedStudio, setSelectedStudio] = useState('')

  const { loading, games, subCategories, allProviders = [] } = useSelector((state) => state.tenantCasino)

  const totalPages = Math.ceil(games?.count / limit)
  const isInitialRender = useDidMountEffect()

  const getProviderName = (id) =>
    allProviders && (allProviders?.rows?.length ? allProviders?.rows : allProviders)?.find((val) => val.masterCasinoProviderId === id)?.name

  const selected = (h) =>
    orderBy === h.value &&
    h.label !== 'Thumbnail' &&
    h.label !== 'Status' &&
    h.label !== 'Sub Category' &&
    h.label !== 'Category'

  const handleShow = (id, subId, active, myName) => {
    setCategoryId(id)
    setSubCategoryId(subId)
    setActive(!active)
    setShow(true)
    setName(myName)
  }

  useEffect(() => {
    dispatch(getCasinoThemesStart({ isTenant: true }))
    dispatch(getTenantCountriesStart())
  }, [])

  const handleDeleteYes = () => {
    dispatch(deleteTenantCasinoGameStart({
      data: { categoryGameId },
      limit,
      pageNo: page,
      casinoCategoryId,
      isActive: statusFilter,
      providerId: selectedProvider,
      aggregatorId: selectedAggregatorId,
      aggregatorCategoryId: selectedAggregatorCategoryId,
      casinoStudioId: selectedStudio
    }))
    setDeleteModalShow(false)
  }

  const handleDeleteModal = (id, myName) => {
    setCategoryGameId(id)
    setDeleteModalShow(true)
    setName(myName)
  }

  const handleYes = () => {
    dispatch(
      updateTenantCasinoGameStatusStart({
        data: {
          code: 'CATEGORY_GAME',
          categoryGameId: categoryId,
          status: active,
          tenantGameSubCategoryId: subCategoryId
        },
        limit,
        pageNo: page,
        casinoCategoryId,
        isActive: statusFilter,
        providerId: selectedProvider,
        aggregatorId: selectedAggregatorId,
        aggregatorCategoryId: selectedAggregatorCategoryId,
        casinoStudioId: selectedStudio
      })
    )
    setShow(false)
  }

  const handleClose = () => setShowModal(false)

  const handleShowModal = (type, data, id) => {
    setGameData(data)
    setCategoryGameId(id)
    setType(type)
    setShowModal(true)
  }

  useEffect(() => {
    dispatch(getAllSubCategoriesStart({
      limit: '',
      pageNo: '',
      categoryId: '',
      search,
      isActive: '',
      orderBy: '',
      sort: ''
    }))
  }, [])

  useEffect(() => {
    setPage(1)
    !isInitialRender && dispatch(
      getAllGamesStart({
        limit,
        pageNo: page,
        casinoCategoryId,
        isActive: statusFilter,
        orderBy,
        sort,
        search,
        providerId: selectedProvider,
        aggregatorId: selectedAggregatorId,
        aggregatorCategoryId: selectedAggregatorCategoryId,
        casinoStudioId: selectedStudio
      })
    )
  }, [
    limit,
    casinoCategoryId,
    statusFilter,
    orderBy,
    sort,
    selectedProvider,
    selectedAggregatorId,
    selectedAggregatorCategoryId,
    selectedStudio
  ])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          dispatch(getAllGamesStart({
            limit,
            pageNo: page,
            casinoCategoryId,
            isActive: statusFilter,
            orderBy,
            sort,
            search,
            providerId: selectedProvider,
            aggregatorId: selectedAggregatorId,
            aggregatorCategoryId: selectedAggregatorCategoryId,
            casinoStudioId: selectedStudio
          })
          )
        } else {
          setPage(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  useEffect(() => {
    dispatch(
      getAllGamesStart({
        limit,
        pageNo: page,
        casinoCategoryId,
        isActive: statusFilter,
        orderBy,
        sort,
        providerId: selectedProvider,
        aggregatorId: selectedAggregatorId,
        aggregatorCategoryId: selectedAggregatorCategoryId,
        casinoStudioId: selectedStudio
      })
    )
  }, [page])

  // Reset selectedStudio when provider or aggregator changes
  useEffect(() => {
    setSelectedStudio('')
  }, [selectedProvider, selectedAggregatorId])

  return {
    limit,
    page,
    loading,
    setLimit,
    setPage,
    totalPages,
    games,
    casinoCategoryId,
    setCasinoCategoryId,
    subCategories,
    show,
    setShow,
    handleShow,
    handleYes,
    handleShowModal,
    showModal,
    type,
    handleClose,
    active,
    gameData,
    categoryGameId,
    search,
    setSearch,
    setDeleteModalShow,
    deleteModalShow,
    handleDeleteYes,
    handleDeleteModal,
    statusFilter,
    setStatusFilter,
    setOrderBy,
    setSort,
    setOver,
    selected,
    sort,
    over,
    selectedProvider,
    setSelectedProvider,
    getProviderName,
    navigate,
    name,
    showGameIds,
    setShowGameIds,
    aggregatorsOptions,
    selectedAggregatorId,
    setSelectedAggregatorId,
    aggregatorsCategoryOptions,
    selectedAggregatorCategoryId,
    setSelectedAggregatorCategoryId,
    selectedStudio,
    setSelectedStudio
  }
}

export default useCasinoGamesListing
